import request from '@/utils/request'
import { getToken } from '@/utils/auth'


/**
  There is a restriction to access response headers when you are using Fetch API over CORS. 
  Due to this restriction, you can access only following standard headers:

  Cache-Control
  Content-Language
  Content-Type
  Expires
  Last-Modified
  Pragma

  Alternatively you can add "Access-Control-Expose-Headers" to the server response headers
  to expose custom headers, for example X-Filename.

 */
export function getEstimateExcel (id) {

  return fetch(
    process.env.VUE_APP_BASE_API + '/estimate/make/' + id,
    {
      headers: {
        Authorization: 'Bearer ' + getToken()
      },
      responseType: 'blob',
    }
  )
  .then( response => {
    
    const filename = response.headers.get("X-Filename")

    response.blob().then( blob => {
      var fileURL = window.URL.createObjectURL(blob);
      var fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);
      fileLink.click();
    })
    
  })

}

export function clone (id) {
  return request({
    url: '/estimate/' + id + '/clone',
    method: 'post'
  })
}